import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import CustomBreadcrumb from '../../../components/base/CustomBreadcrumb';
import CustomListComponent from '../../../components/base/CustomListComponent';
import { createAction } from '../../../utils';
import ContentSections from '../../../components/base/ContentSections';
import MembershipInfoCard from '../../../components/customer/MembershipInfoCard';
import AuthButton from '../../../components/base/AuthButton';
import { PermissionCodes } from '../../../config/PermissionCodes';
import { ADMINISTRATOR_TYPES } from '../../../config/CustomEnums';

function AdminDetail() {
  const history = useHistory();
  const dispatch = useDispatch();
  const params = useParams();

  const { admin } = useSelector((state) => ({
    admin: state.admin.oneAdmin || {},
  }));

  const getSections = () => {
    const isMerchantAppAccount = admin.adminType === ADMINISTRATOR_TYPES.MERCHANT_APP_ACCOUNT
    
    const stateFields = isMerchantAppAccount ? [
      [{ title: 'Active', field: 'displayActive' }],
    ] : [
      [{ title: 'Active', field: 'displayActive' }],
      [{ title: 'Superadmin status', field: 'displayIsSuper' }]
    ]
    const generalFields = [
      [{ title: 'Name', field: 'username' }],
      [{ title: 'Admin type', field: 'displayAdminType' }],
      ...(isMerchantAppAccount ? [
        [{
          title: 'Related brands and store(s)', customRender: (<>
            {
              Object.keys(admin.merchantStoresGroupByBrand)?.length > 0 ? Object.entries(admin.merchantStoresGroupByBrand)?.map(([displayBrandName, brandStores]) => (
                <div className='custom-record-normal-font custom-timeline-time-color list-new-line'>
                  <div>{displayBrandName}</div>
                  <ul style={{ marginBottom: 0 }}>
                    {brandStores?.map((store) => (
                      <li>{`[${store.pk}]${store.name}`}</li>
                    ))}
                  </ul>
                </div>
              )) : "-"
            }
          </>)
        }],
      ] : []),
      [{ title: 'Password', field: 'displayPassword' }],
    ]
    let sections = [
      <MembershipInfoCard
        title={'INFORMATION'}
        data={admin}
        fields={generalFields}
      />,
      <MembershipInfoCard
        title={'Personal Information'}
        data={admin}
        fields={[
          [{ title: 'First name', field: 'firstName' }],
          [{ title: 'Last name', field: 'lastName' }],
          [{ title: 'Email address', field: 'email' }],
        ]}
      />,
      ...(isMerchantAppAccount ? [] : [
        <MembershipInfoCard
          title={'Status'}
          data={admin}
          fields={stateFields}
        />
      ]),
      ...(isMerchantAppAccount || !admin.isSuperuser ? [<MembershipInfoCard
        title={'Permission'}
        data={admin}
        fields={[
          [{ title: 'Permission Groups', field: 'displayGroups' }],
          [
            {
              title: 'Administrator permission',
              field: 'displayPermissions',
            },
          ],
        ]}
      />] : []),
      <MembershipInfoCard
        title={'Important dates'}
        data={admin}
        fields={[
          [{ title: 'Last login', field: 'displayLastLogin' }],
          [{ title: 'Date joined', field: 'displayDateJoined' }],
        ]}
      />,
      <MembershipInfoCard
        title={'GENERAL'}
        data={admin}
        fields={[
          [{ title: 'Status', field: 'status' }],
          [{ title: 'Creation time', field: 'displayDetailCreationDate' }],
          [{ title: 'Last modified time', field: 'displayDetailLastModifiedTime' }],
          [{ title: 'Last modified by', field: 'displayLastModifiedBy' }],
        ]}
      />,
    ];

    return sections;
  };

  const tabs = [
    {
      name: 'Detail',
      content: (
        <div className="scroll-container-common">
          <ContentSections
            sections={getSections()}
            hidePreview={true}
          // sectionStyle="detail-info-section-item"
          />
        </div>
      ),
    },
  ];

  const buttons = [
    <AuthButton
      title="Edit"
      action={() => {
        dispatch({ type: 'admin/clearData' });
        history.push({
          pathname: 'edit/',
        });
      }}
      requires={PermissionCodes.changeAdministrator}
    />,
  ];

  useEffect(() => {
    dispatch({ type: 'admin/clearData' });
  }, [dispatch]);

  useEffect(() => {
    const id = params.id;
    dispatch(createAction('admin/getOneAdmin')({ id, type: 'detail' }));
  }, [dispatch, params]);

  return (
    <div className="customer">
      <CustomListComponent
        caution={{
          detail: '',
          title: admin.name,
        }}
        defaultActiveKey={tabs[0].name}
        breadcrumb={<CustomBreadcrumb name={admin.name} />}
        buttons={buttons}
        tabs={tabs}
      />
    </div>
  );
}

export default AdminDetail;
